import request from '@/utils/request';

const base = '/admin/complaint_feedback_records';

async function call(config) {
  const response = await request(config);
  if (Number(response.data.code) !== 200) throw new Error(response.data.message || '请求失败');
  return response.data.data;
}

export function getComplaintRecords(params) { return call({ url: base, method: 'get', params }); }
export function getComplaintRecord(id) { return call({ url: `${base}/${id}`, method: 'get' }); }
